import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Clock, Brain } from 'lucide-react';
export function ProblemSection() {
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  return <section className="py-24 px-6 bg-[#0f1525]" data-id="element-121">
      <div className="max-w-4xl mx-auto" data-id="element-122">
        <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-16" data-id="element-123">
          <motion.div variants={item} className="text-center" data-id="element-124">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#f5efe3]" data-id="element-125">
              Tu problema no es que pienses mucho. <br data-id="element-126" />
              Tu problema es que{' '}
              <span className="text-[#c9956b]" data-id="element-127">
                piensas en el lugar equivocado
              </span>
              .
            </h2>
            <p className="text-lg text-[#8b9bb4] max-w-2xl mx-auto" data-id="element-128">
              La noche te deja sin distracciones. Y tu mente, que lleva todo el
              día tragándose cosas, aprovecha para abrir la oficina.
            </p>
          </motion.div>

          <motion.div variants={item} className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-129">
            <div className="bg-[#1a2332] p-8 rounded-2xl border border-white/5 shadow-xl" data-id="element-130">
              <h3 className="text-xl font-serif font-semibold mb-6 flex items-center gap-3 text-[#f0e6d3]" data-id="element-131">
                <Brain className="w-5 h-5 text-[#c9956b]" data-id="element-132" />
                La Oficina Mental a Oscuras
              </h3>
              <ul className="space-y-4 text-[#8b9bb4]" data-id="element-133">
                <li className="flex items-start gap-3" data-id="element-134">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#c9956b] mt-2.5" data-id="element-135" />
                  <span data-id="element-136">Pendientes que olvidaste anotar</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-137">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#c9956b] mt-2.5" data-id="element-138" />
                  <span data-id="element-139">Culpas por no ser "suficiente"</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-140">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#c9956b] mt-2.5" data-id="element-141" />
                  <span data-id="element-142">Escenarios catastróficos ("y si...")</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-143">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#c9956b] mt-2.5" data-id="element-144" />
                  <span data-id="element-145">Listas invisibles interminables</span>
                </li>
              </ul>
            </div>

            <div className="space-y-6" data-id="element-146">
              <div className="flex gap-4" data-id="element-147">
                <div className="w-12 h-12 rounded-full bg-[#c9956b]/10 flex items-center justify-center shrink-0" data-id="element-148">
                  <AlertCircle className="w-6 h-6 text-[#c9956b]" data-id="element-149" />
                </div>
                <div data-id="element-150">
                  <h4 className="font-bold text-[#f0e6d3] mb-2" data-id="element-151">
                    El error que nadie te dice
                  </h4>
                  <p className="text-[#8b9bb4]" data-id="element-152">
                    De noche NO se "resuelve". De noche se{' '}
                    <span className="text-[#c9956b] font-medium" data-id="element-153">cierra</span>.
                  </p>
                </div>
              </div>

              <div className="flex gap-4" data-id="element-154">
                <div className="w-12 h-12 rounded-full bg-[#c9956b]/10 flex items-center justify-center shrink-0" data-id="element-155">
                  <Clock className="w-6 h-6 text-[#c9956b]" data-id="element-156" />
                </div>
                <div data-id="element-157">
                  <h4 className="font-bold text-[#f0e6d3] mb-2" data-id="element-158">
                    La reunión obligatoria
                  </h4>
                  <p className="text-[#8b9bb4]" data-id="element-159">
                    Intentar resolver tu vida a medianoche es tener una reunión
                    contigo mismo, sin agenda y con miedo.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}